import React from "react";
import NutritionField from "./NutritionField";

const formatNutrientValue = (value) => {
    if (typeof value !== "number" || Number.isNaN(value)) {
        return "n/a";
    }
    return value.toFixed(1);
};

const NutritionSection = ({ showNutrition, nutrition }) => {
    if (!showNutrition) {
        return null;
    }

    if (!nutrition) {
        return <div class="ui tiny active inline loader"></div>;
    }

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignText: "center",
                    margin: "0px 10px",
                }}
            >
                <NutritionField
                    title={"Calories"}
                    value={formatNutrientValue(nutrition?.calories)}
                    color={"200, 200, 200"}
                />
                <NutritionField
                    title={"Carbs"}
                    value={formatNutrientValue(nutrition?.carbohydrates)}
                    color={"248, 214, 137"}
                />
                <NutritionField
                    title={"Fats"}
                    value={formatNutrientValue(nutrition?.fats)}
                    color={"136, 175, 248"}
                />
                <NutritionField
                    title={"Proteins"}
                    value={formatNutrientValue(nutrition?.proteins)}
                    color={"241, 161, 146"}
                    isLast={true}
                />
            </div>
        </div>
    );
};

export default NutritionSection;
